(function () {
  var addressInput = document.getElementById('PshQuoteAddress');
  var mapLink = document.getElementById('PshQuoteMapLink');

  if (!addressInput || !mapLink) return;

  function updateMapLink() {
    var address = addressInput.value.trim();
    if (!address) {
      mapLink.href = 'https://www.google.com/maps';
      return;
    }
    mapLink.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address);
  }

  addressInput.addEventListener('input', updateMapLink);
  updateMapLink();
})();
